import * as _ from 'underscore';
import { IUserInfo } from '../models/IUserInfo';
import { IUser } from '../ServerApi/types/IUser';

export module UserMapper {

  export function map(serverApiUsers: IUser[]): IUserInfo[] {
    return _.map(serverApiUsers, mapOne);
  }

  export function mapOne(u: IUser): IUserInfo {
    return {
      authId:      u.authId,
      displayName: u.displayName,
      domainName:  u.domainName,
      id:          u.id,
      readOnly:    u.readOnly,
      username:    u.username
    };
  }

}
